<template>
  <span>
    <div
      class="background-wallpaper"
      style="background-color: #2a2a2a; opacity: 1"
    ></div>
    <div
      class="banner"
      v-if="artist.header !== 0"
      :style="
        'background-image:url(' +
        artist.header.url +
        '); box-shadow: 0 0 20px 12px black;'
      "
    ></div>
    <div
      class="banner"
      v-else
      style="
        background-image: url(https://hthayat.haberturk.com/im/2020/09/01/ver1599458537/1074763_1920x1080.jpg);
      "
    ></div>

    <section class="spaced" style="margin-top: -200px">
      <div class="container content flex">
        <div
          class="text-center push-center circle head-profile"
          style="
            width:250px; height: 259px; margin:auto; margin-top: 50px;
            box-shadow: 0 0 16px 6px #00000042;
            border: 8px solid var(--primary);
            "
        >
          <div
            v-if="artist.profile !== 0"
            :key="artist.id"
            class="text-left head-profile-inner"
            :style="'background-image:url(' + artist.profile.url + ')'"
          ></div>
        </div>
      </div>
      <div class="container content flex">
        <div class="column c8 push-center">
          <h1 class="text-center" style="margin-bottom: 40px">
            {{ artist.name }}
          </h1>
          <p class="text-center" v-html="artist.biography"></p>

          <router-link to="/booking" class="artistbook">
            BOOK THIS ARTIST
            <i class="far fa-calendar-plus"></i>
          </router-link>
        </div>
      </div>
    </section>

    <span v-if="artist.albums.length !== 0">
      <section class="spaced">
        <div class="container content">
          <h1 class="text-center">RELEASES</h1>
        </div>

        <div class="container content flex">
          <div
            class="column c4 push-center"
            v-for="album in artist.albums"
            :key="album.id"
            style="margin-bottom: 40px"
          >
            <router-link :to="{ name: 'release', params: { id: album.slug } }">
              <img
                :src="album.AlbumArtwork.url"
                style="
                  width: 80%;
                  margin-bottom: 20px;
                  box-shadow: 0 0 16px 3px #00000042;
                  overflow: visible;
                "
              />
              <h2 class="text-center">{{ album.AlbumTitle }}</h2>
              <h3 class="text-center">Released On: {{ album.AlbumRelease }}</h3>
            </router-link>
          </div>
        </div>
      </section>
    </span>
    <span v-if="artist.compiledin.length !== 0">
      <section class="spaced">
        <div class="container content">
          <h1 class="text-center">IN COMPILATION</h1>
        </div>

        <div class="container content flex">
          <div
            class="column c4 push-center"
            v-for="compilation in artist.compiledin"
            :key="compilation.id"
            style="margin-bottom: 40px"
          >
            <router-link
              :to="{ name: 'release', params: { id: compilation.slug } }"
            >
              <img
                :src="compilation.AlbumArtwork.url"
                style="
                  width: 80%;
                  margin-bottom: 20px;
                  box-shadow: 0 0 16px 3px #00000042;
                  overflow: visible;
                "
              />
              <h2 class="text-center">{{ compilation.AlbumTitle }}</h2>
              <h3 class="text-center">
                Released On: {{ compilation.AlbumRelease }}
              </h3>
            </router-link>
          </div>
        </div>
      </section>
    </span>
  </span>
</template>

<script>
import axios from 'axios'

export default {
  name: 'artist',
  data () {
    return {
      artist: []
    }
  },
  metaInfo () {
    return {
      title: `${this.artist.name} @ Patronus Records`,
      meta: [
        { name: 'description', content: this.metaDesc },
        { property: 'og:title', content: this.metaTitle },
        { property: 'og:site_name', content: this.metaSite },
        { property: 'og:description', content: this.metaDesc },
        { property: 'og:type', content: 'profile' },
        { property: 'og:url', content: this.metaUrl },
        { property: 'og:image', content: this.metaImage }
      ]
    }
  },
  created () {
    axios
      .get(
        'https://admin.patronusrecords.com/artists/?slug=' +
          this.$route.params.id
      )
      .then((response) => {
        this.artist = response.data[0]
        this.metaImage = this.artist.profile.url
        this.metaDesc = this.artist.biography
        this.metaUrl = 'https://patronusrecords.com/artist/' + this.artist.slug
        this.metaSite = this.artist.name + ' @ Patronus Records'
        this.metaTitle = this.artist.name + ' @ Patronus Records'
        // window.document.title = this.artist.name + ' @ Patronus Records'
      })
  }
}
</script>
<style scoped>
#app {
  background-color: red;
}
</style>
<style>
.banner {
  width: 100vw;
  /* height: 420px; */
  padding-bottom: 20%;
  min-height: 250px;
  display: inline-block;
  vertical-align: top;
  position: relative;
  overflow: hidden;
  background-position: center center;
  background-size: cover;
}
.head-profile {
  margin-top: 50px;
  width: 250px !important;
  height: 250px !important;
}
.head-profile-inner {
  width: 100%;
  height: 100%;
  display: block;
  background-position: center center;
  background-size: cover;
}
.artistbook {
  padding: 15px;
  background-color: var(--primary);
  border-radius: 10px;
  width: 100%;
  display: block;
  max-width: 180px;
  text-align: left;
  margin: auto;
  position: relative;
}
.artistbook:hover {
  background-color: var(--secondary);
}
.artistbook i {
  position: absolute;
  right: 19px;
  color: white;
}
.artistbook:hover {
  transform: scale(1.05);
}
.artistbook:hover i {
  transform: scale(1.3);
}
</style>



// WEBPACK FOOTER //
// src/pages/artist.vue